<mat-card>
    <mat-card-header style="margin-bottom: 20px">

        <mat-card-title>Gestão de Relacionamento</mat-card-title>

        <!-- ADD BUTTON -->
        <button mat-mini-fab color="warning" style=" margin-left: 10px" [matMenuTriggerFor]="adicionar">
            <mat-icon>add_circle</mat-icon>
        </button>
        <!-- / ADD BUTTON -->

        <mat-menu #adicionar="matMenu">
            <button mat-menu-item (click)="openCadastroRelacionamento()">Histórico</button>
            <button mat-menu-item (click)="openCadastroOportunidade()">Oportunidade</button>
            <button mat-menu-item (click)="openCadastroAtividade()">Atividade</button>
        </mat-menu>

        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Consultar"
            (click)="openFiltrar()">
            <mat-icon>search</mat-icon>
        </button>

        <button mat-mini-fab color="warning" style=" margin-left: 10px" matTooltip="Exportar Gestão de Relacionamento"
            (click)="exportar()">
            <mat-icon>cloud_download</mat-icon>
        </button>

        <div fxLayout="row" fxLayoutAlign="center center" fxFlex="30%">
            <span *ngIf="dataInicio && dataFim">
                <strong>Filtrado de: {{dataInicio | date:'dd/MM/yyyy'}} a {{ dataFim | date:'dd/MM/yyyy'}} </strong>
            </span>
        </div>
    </mat-card-header>
    <mat-card-content class="custom-datatable">
        <ngx-datatable 
            #table 
            class='material' 
            [loadingIndicator]="loadingIndicator" 
            [columns]="columns"
            [columnMode]="'force'" 
            [headerHeight]="50" 
            [footerHeight]="50" 
            [rowHeight]="'auto'" 
            [limit]="params.per_page" 
            [rows]='rows' 
            (sort)="onSort($event)"
            >

            <ngx-datatable-column name="Tipo de Registro" prop="tipo_registro" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{row.tipo_registro}}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Data" prop="data" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{row.data | date:'dd/MM/yyyy'}}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Conta/Cliente" prop="cliente" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{(row.numero_xp != null)? row.numero_xp +' | '+row.cliente : row.cliente}}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Assessor/Escritório" prop="assessor" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{row.assessor +' | '+ row.escritorio}}
                    </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Assunto" prop="assunto" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{row.assunto}}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Observação" prop="observacao" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span class="texto">
                        {{row.observacao}}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Resposta" prop="cliente_aceitou" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="isResponse(row)">
                        <div fxLayout="row wrap">
                            <div fxFlex.gt-sm="100%">
                                <strong>Cliente Aceitou? </strong>{{row.cliente_aceitou? 'SIM' : 'NÃO'}}
                            </div>
                        </div>   
                        <div fxLayout="row wrap">
                            <div fxFlex.gt-sm="100%">
                                <strong>Data da Resposta: </strong>{{row.data_resposta | date:'dd/MM/yyyy'}}
                            </div>
                        </div>
                        <div fxLayout="row wrap">
                            <div fxFlex.gt-sm="100%">
                                <strong>Valor: </strong>R$ {{row.valor_resposta | number : '1.2-2'}}
                            </div>
                        </div>
                        <div fxLayout="row wrap">
                            <div fxFlex.gt-sm="100%">
                                <strong>Observação: </strong>{{getObservacao(row)}}
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-column>

        </ngx-datatable>
        <div style="padding: 5px 10px">
            <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>